export default __webpack_public_path__ + "static/media/4.d1d837a3.jpg";